export default (d) => {
  const locale = localStorage.getItem('ulty-lng');
  const dt = new Date(d)
  return dt.toLocaleString(locale)
}